export const loadState = () => {
	try {
		const serializedState = localStorage.getItem('state');
		if (serializedState === null) {
			return undefined;
		}
		return JSON.parse(serializedState);
	} catch (err) {
		return undefined;
	}
};

export const saveState = state => {
	console.log(state);
	try {
		const serializedState = JSON.stringify({ agency: state.agency, date: state.date });
		localStorage.setItem('state', serializedState);
	} catch (err) {
		// ignore
	}
};



/** WEBPACK FOOTER **
 ** ./src/localStorage.js
 **/